module.exports = __webpack_public_path__ + "static/media/javascript1.7768f816.png";